import PresupuestoView from './views/PresupuestoView.vue'

export default [
  {
    path: '/presupuesto',
    name: 'presupuesto',
    component: PresupuestoView
  }
]
